import React from 'react';
import { Facebook } from 'lucide-react';

const About = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <header className="border-b border-gray-200 bg-white sticky top-0 z-10">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center space-x-6">
            {/* VideBits Logo */}
            <a href="/" className="flex items-center space-x-3 hover:opacity-80 transition-opacity cursor-pointer">
              <img 
                src="/logo-transparent.svg" 
                alt="VideBits Logo" 
                className="w-8 h-8"
              />
              <h1 className="text-xl font-light text-gray-900">VideBits</h1>
            </a>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-videbits-500 shadow-2xl rounded-lg text-center px-6 py-12">
            <div className="mb-4">
              <h1 className="text-2xl text-white mb-6">About VideBits</h1>
              <p className="text-3xl md:text-4xl font-bold text-white mb-8">Know What’s Next.</p>
              
              <div className="text-base px-6 text-videbits-100 text-left space-y-4">
                <p>
                  VideBits is an AI-powered entertainment intelligence platform covering film, TV and games. It connects fragmented information about titles, people, studios, production companies, publishers, projects, releases, platforms and events.
                </p>
                
                <p>
                  For audiences, VideBits helps answer: <strong>What should I watch or play next?</strong> Search, the release calendar and personalised tools make it easier to discover what is available now and what is coming soon.
                </p>
                
                <p>
                  For industry professionals, VideBits is being built to answer a different question: <strong>What is likely to happen next?</strong> Insider connects projects, talent, companies and events to surface emerging activity, relationships and momentum earlier.
                </p>
                
                <p>
                  Underneath both experiences is a growing entertainment knowledge graph. The long-term path is simple: entertainment data → knowledge graph → intelligence → evidence-based prediction.
                </p>

                <p>
                  VideBits goes beyond cataloguing what has already happened. Its ambition is to understand what is happening now—and help people know what’s next.
                </p>
                
                <p>
                  For any questions or feedback about VideBits, please don't hesitate to <a href="/help" className="text-white underline hover:no-underline">contact our support team</a>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 py-3">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-1 md:space-y-0">
            <div className="flex items-center space-x-6 text-sm text-gray-600">
              <a href="/about" className="hover:underline">About</a>
              <a href="/privacy" className="hover:underline">Privacy</a>
              <a href="/terms" className="hover:underline">Terms</a>
              <a href="/help" className="hover:underline">Help</a>
            </div>
            <div className="flex items-center space-x-4 text-xs text-gray-500">
              <a
                href="https://www.facebook.com/videbits"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="VideBits on Facebook"
                className="hover:text-gray-900 transition-colors"
              >
                <Facebook className="w-4 h-4" />
              </a>
              <span>© {new Date().getFullYear()} VideBits Ltd</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default About;
